import {
  DialogContent,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import React from "react";

const STATUS = ["PENDING", "APPROVED", "REJECTED"];

export const QuoteViewModal = ({ open, onClose, quote }: any) => {
  const [form, setForm] = React.useState<any>({});

  React.useEffect(() => {
    if (quote) setForm(quote);
  }, [quote]);

  const handleChange = (key: string, value: any) => {
    setForm((prev: any) => ({ ...prev, [key]: value }));
  };

  const handleOptionQtyChange = (index: number, value: number) => {
    const updated = [...form.options];
    updated[index].quantity = value;
    setForm({ ...form, options: updated });
  };

  const handleUpdate = () => {
    console.log("UPDATE", form);
  };

  const handleDelete = () => {
    console.log("DELETE", form.id);
  };

  if (!quote) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Quote #{quote.id}</DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <TextField
            label="Estimated Price"
            value={form.estimatedPrice || ""}
            disabled
            fullWidth
          />

          <TextField
            label="Comments"
            value={form.comments || ""}
            onChange={(e) => handleChange("comments", e.target.value)}
            multiline
            rows={3}
            fullWidth
          />

          <Divider />

          <Typography variant="subtitle2">Options</Typography>

          {form.options?.map((opt: any, index: number) => (
            <TextField
              key={opt.id}
              label={`Option #${opt.id} Quantity`}
              type="number"
              value={opt.quantity}
              onChange={(e) =>
                handleOptionQtyChange(index, Number(e.target.value))
              }
              fullWidth
            />
          ))}

          <Stack direction="row" spacing={2}>
            <Button variant="contained" onClick={handleUpdate}>
              Update
            </Button>

            <Button color="error" onClick={handleDelete}>
              Delete
            </Button>

            <Button onClick={onClose}>Close</Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
